<template>
    <div id="newsletter" v-if="newsletterId">
      <newsletter-nav
        :newsletterId="newsletterId"
      ></newsletter-nav>

      <email
        :emailId="newsletterId"
        emailType="newsletter"
        :sendEmailConfirmation="sendEmailConfirmation"
      />
    </div>
</template>

<script>
import Email from '@/components/Email'
import NewsletterNav from '@/components/NewsletterNav'

export default {
  props: {
    newsletterId: {
      type: [ Number, String ],
      default: undefined,
      required: true
    },

    sendEmailConfirmation: {
      type: Boolean,
      default: false
    }
  },

  components: {
    'email': Email,
    'newsletter-nav': NewsletterNav
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Newsletter.vue